if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        document.querySelectorAll('body > .size-chart-overlay').forEach((overlay) => overlay.remove());

        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('overflow-hidden-mobile');
        document.body.classList.remove('overflow-hidden-tablet');
        document.body.classList.remove('overflow-hidden-desktop');
        document.body.style.overflow = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            // Ensure Shiprocket scripts and form inputs are initialized for Quick Add modal checkout
            const modalForm = this.modalContent.querySelector('form[action*="/cart/add"]');
            if (modalForm) {
              let urlInput = modalForm.querySelector('input[name="productUrl"]');
              if (!urlInput) {
                urlInput = document.createElement('input');
                urlInput.type = 'hidden';
                urlInput.name = 'productUrl';
                modalForm.appendChild(urlInput);
              }
              const openerUrl = opener.getAttribute('data-product-url') || '';
              const cleanUrl = openerUrl.split('?')[0].replace(/^\/collections\/[^\/]+\/products\//, '/products/');
              if (cleanUrl) {
                urlInput.value = cleanUrl;
              }
            }
            if (!document.getElementById('fastrrCollectionPage')) {
              const cp = document.createElement('input');
              cp.type = 'hidden';
              cp.id = 'fastrrCollectionPage';
              cp.value = 'true';
              document.body.appendChild(cp);
            }
            if (typeof window.loadShiprocketScripts === 'function') {
              window.loadShiprocketScripts();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            // Trigger active state update for wishlist buttons in the modal
            if (window.ShopifyWishlist) {
              window.ShopifyWishlist.updateButtons();
            }

            if (typeof window.initProductCoupons === 'function') {
              window.initProductCoupons();
            }

            super.show(opener);

            if (typeof window.initProductCoupons === 'function') {
              window.initProductCoupons();
            }
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);

        // Wrap price and share/wishlist container in a row
        const price = productElement.querySelector('[id^="price-"]');
        const share = productElement.querySelector('.product__share-wishlist-container');
        if (price && share) {
          const row = document.createElement('div');
          row.className = 'price-share-row';
          price.parentNode.insertBefore(row, price);
          row.appendChild(price);
          row.appendChild(share);
        }
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        // Remove empty installment block in quick view without removing the price block
        const installment = productElement.querySelector('.installment');
        if (installment) {
          const installmentContainer = installment.closest('div');
          if (installmentContainer && installmentContainer.parentNode && installmentContainer.parentNode.classList.contains('product-info-block--price')) {
            installmentContainer.remove();
          } else {
            installment.remove();
          }
        }

        // Remove empty share block if share button was moved into price row
        const shareBlock = productElement.querySelector('.product-info-block--share');
        if (shareBlock && !shareBlock.querySelector('.product__share-wishlist-container')) {
          shareBlock.remove();
        }
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
